// Preset keys understood by the backend's s3-uploads/initiate/ endpoint. Env overrides exist for
// parity with the old Cloudinary preset config; the fallbacks are the backend's actual keys.
export const UploadType = {
    BRAND: process.env.REACT_APP_UPLOAD_PRESET_NAME_BRAND || 'brand',
    CAMPAIGN: process.env.REACT_APP_UPLOAD_PRESET_NAME_CAMPAIGN || 'campaign',
    BANNER: process.env.REACT_APP_UPLOAD_PRESET_NAME_BANNER || 'banner',
    BILLING: process.env.REACT_APP_UPLOAD_PRESET_NAME_BILLING || 'billing',
} as const

export type UploadType = (typeof UploadType)[keyof typeof UploadType]
